import { jsx as _jsx } from "react/jsx-runtime";
import { ProjectDashboard } from '../../components/ProjectDashboard';
/**
 * Project overview page.
 * Uses the original ProjectDashboard component with full functionality.
 */ export function ProjectOverview() {
    return /*#__PURE__*/ _jsx(ProjectDashboard, {});
}
